export { default } from "./useTeacherSubjectMutation";
